<template>
  <div class="deleted d-flex flex-column justify-content-center align-items-center">
    <div class="image-container mb-4">
      <img src="../../public/img/Consagradas_logo_login.png" class="img-fluid" />
    </div>
    <div class="card p-4 text-center">
      <p>Formulario de soporte</p>
                <label class="text-left w-100">Tipo:</label>
                <multiselect v-model="form_save.type" label="name" :options="typeTMP"
                    selectLabel='Click para elegir' selectedLabel="Seleccionado"
                    deselectLabel='Click para remover' select-label="Seleccionar" placeholder="Seleccione"
                    style="padding-top: 5px; padding-bottom: 5px; margin-bottom: 10px;">
                </multiselect>
      <label class="text-left w-100">Correo electrónico</label>
      <input type="email" v-model="form_save.email" class="form-control mb-3" placeholder="Ingresa tu correo" />
      <label class="text-left w-100">Descripción</label>
      <textarea v-model="form_save.description" class="form-control mb-3" rows="5" placeholder="Escribe la descripción de tu duda o soporte"></textarea>
      <button @click.prevent="saveSupport" class="btn btn-primary">Enviar</button>
    </div>

  </div>
</template>

<script>
  import EmailValidator from 'email-validator';
  import { mapActions } from 'vuex';
  import Multiselect from "vue-multiselect";

  export default {
    components: {
          Multiselect,         
      },
    data() {
      return{
      form_save: {
        type: "",
        email: "",
        description: "",
      },
      typeTMP: [
        { id: 1, name: "Problema para acceder" },
        { id: 2, name: "Problema con la app" },
        { id: 3, name: "Dudas de como funciona" },
        { id: 4, name: "Otro" },
      ],
      };
  },
  methods: {
      ...mapActions(["createData"]),
      saveSupport() {
        let validate = EmailValidator.validate(this.form_save.email);
        if (!validate) {
          Swal.fire({
            title: "Email inválido",
            text: "Debes escribir un email válido para poder continuar",
            icon: "warning",
            confirmButtonColor: "#AA1E2E",
          });
        } 
        if (this.form_save.type == "") {
          Swal.fire({
            title: "Tipo no seleccionado",
            text: "Debes seleccionar un tipo para poder continuar",
            icon: "warning",
            confirmButtonColor: "#AA1E2E",
          });
        }
        if (this.form_save.description == "") {
          Swal.fire({
            title: "Descripción vacía",
            text: "Debes escribir una descripción para poder continuar",
            icon: "warning",
            confirmButtonColor: "#AA1E2E",
          });
        }
        else {
          let data_to_send={
            email: this.form_save.email,
            description: this.form_save.description,
            type: this.form_save.type.name,
          }
          let form = {
            url: "support_form/save",
            data: data_to_send
          };

          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Mensaje enviado",
                  text: "Hemos enviado tu mensaje al equipo de soporte, te responderemos lo más pronto posible",
                  icon: "success",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                  confirmButtonColor: "#AA1E2E",
                }).then((result) => {
                  location.reload();
                }); 
              }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              alert("Ocurrió un error, intente más tarde");
            });
        }
      },
    },
};

</script>
<style>
.deleted {
  height: 100vh;
  width: 100vw;
  background-color: #AA1E2E ;
}

.card {
  max-width: 400px;
  width: 100%;
}

.image-container {
  max-width: 300px;
  width: 100%;
}
.btn-primary {
  background-color: transparent;
  border: 2px solid #AA1E2E;
  color: #AA1E2E;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.btn-primary:hover {
  background-color: #AA1E2E !important;
  border-color: #AA1E2E !important;
  color: white;
}
.form-control:focus {
  border-color: #AA1E2E;
  box-shadow: 0 0 0 0.2rem rgba(170, 30, 46, 0.25);
}

</style>
